import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="iso-8859-1"?>

<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 484.601 484.601" style="enable-background:new 0 0 484.601 484.601;" xml:space="preserve">
<g>
	<g>
		<g>
			<path d="M482.457,183.951c-5.6-17.1-20.7-29-38.6-30.3l-116.7-8.5l-44.2-108.3c-6.8-16.6-22.7-27.3-40.7-27.3
				s-33.9,10.7-40.7,27.4l-44.1,108.4l-116.7,8.5c-17.9,1.3-33.1,13.2-38.6,30.3s-0.3,35.6,13.5,47.2l89.4,75.5l-28,113.6
				c-3.3,13.2-0.4,26.9,7.9,37.5c8.4,10.7,21.4,17.1,34.8,17.1c8.1,0,16.1-2.3,23.2-6.7l99.4-61.7l99.4,61.7
				c7.1,4.4,15.1,6.7,23.2,6.7c13.4,0,26.4-6.4,34.8-17.1c8.3-10.6,11.2-24.3,7.9-37.5l-28-113.6l89.4-75.5
				C482.657,219.551,487.957,201.051,482.457,183.951z M446.857,204.951l-97.6,82.3c-5,4.2-7.2,10.9-5.6,17.2l30.5,124
				c0.8,3.1,0.2,5.8-1.6,8.1c-3,3.8-8.4,5.1-12.8,2.4l-108.5-67.3c-2.8-1.7-5.9-2.6-9-2.6s-6.3,0.9-9,2.6l-108.5,67.4
				c-4.4,2.7-9.8,1.5-12.8-2.4c-1.8-2.3-2.4-5.1-1.6-8.1l30.5-124c1.6-6.3-0.6-13-5.6-17.2l-97.6-82.3c-4.5-3.8-3.6-8.5-3-10.4
				s2.6-6.2,8.5-6.6l127.3-9.3c6.5-0.5,12.2-4.6,14.6-10.6l48.2-118.2c2.2-5.4,7-6,8.9-6s6.7,0.6,8.9,6l48.2,118.2
				c2.5,6,8.1,10.2,14.6,10.6l127.3,9.3c5.8,0.4,7.9,4.8,8.5,6.6C450.357,196.451,451.357,201.151,446.857,204.951z"/>
		</g>
	</g>
</g>















</svg>
`,
      }}
    />
  );
};
